export const version = {"build_date":"Tue, 03 Nov 2026 08:10:07 GMT"};